import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CashierApi from "../../utility/CashierApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function ClearCart({ id }) {
  const { fetchOnlyData } = CashierApi();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => fetchOnlyData(`carts/clear-cart/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cart"] }); // Refresh relevant queries
    },
    // onError: (error) => {
    //   console.error("Error clearing cart:", error);
    // },
  });

  const handleDelete = () => {
    mutation.mutate();
  };

  return (
    <div>
      <DeleteForeverIcon
        sx={{ fontSize: "40px" }}
        className="text-red-600 cursor-pointer"
        onClick={handleDelete}
      />
    </div>
  );
}

export default ClearCart;
